import {cn} from '@sollapay/ui';
import {Badge, IconBox, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {getAssetTypeIcon} from './asset-header.config';
import {getAssetHeaderModel} from './asset-header.utils';
import {AssetFactsList} from './AssetFactsList';

import type {AssetSummaryDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface AssetHeaderProps {
  asset: AssetSummaryDTO;
  className?: string;
}

export const AssetHeader: FC<AssetHeaderProps> = ({asset, className}) => {
  const {t} = useTranslation('trustAccounts');
  const {title, typeBadge, facts, showEmptyState} = getAssetHeaderModel(asset, t);

  return (
    <div className={cn('flex items-start gap-3', className)}>
      <IconBox icon={getAssetTypeIcon(asset.assetType)} shadow iconColor="tertiary" />

      <div className="flex min-w-0 flex-1 flex-col">
        <Typography as="h2" size="display-xs" weight="semibold">
          {title}
          {typeBadge && (
            <Badge variant="neutral" size="sm" className="ms-2 align-middle">
              {typeBadge}
            </Badge>
          )}
        </Typography>

        {facts.length > 0 ? (
          <AssetFactsList facts={facts} />
        ) : (
          showEmptyState && (
            <Typography size="sm" className="text-fg-quaternary">
              {t('view.buyers.detail.assetHeader.noIdentifiers')}
            </Typography>
          )
        )}
      </div>
    </div>
  );
};
